export enum LinkCarouselType {
  RelatedCategory = 'Related Category',
  ChildCategory = 'Child Category',
}
